import { render, staticRenderFns } from "./DispositivosVinculados.vue?vue&type=template&id=35238ce5&"
import script from "./DispositivosVinculados.vue?vue&type=script&lang=js&"
export * from "./DispositivosVinculados.vue?vue&type=script&lang=js&"
import style0 from "./DispositivosVinculados.vue?vue&type=style&index=0&id=35238ce5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports